import { FC, useState } from 'react'
import { observer } from 'mobx-react'
import { useTranslation } from 'next-i18next'
import { useStores } from '../../../utils'
import { ILocationBase } from '../../../types'
import { InputSearchGroupWithDropDown } from '../InputSearchGroupWithDropDown'
import { LocationSelectionField } from '../LocationSelectionField'

type Props = {
  selectedLocations: ILocationBase[]
  setFieldValue: (locations: ILocationBase[]) => void
}

export const LocationSearchField: FC<Props> = observer(({ selectedLocations, setFieldValue }) => {
  const { t } = useTranslation(['search'])
  const { companies } = useStores()
  const [isDropDownOpen, setIsDropDownOpen] = useState(false)
  const [searchResult, setSearchResult] = useState<ILocationBase[]>([])

  const searchResultExcludingSelected = searchResult.filter((location) => {
    const isSelected = selectedLocations.some((l) => l.slug === location.slug)
    return !isSelected
  })

  const onInputFinished = async (searchWord: string) => {
    const locations = await companies.fetchLocations({
      searchWord,
      limit: 20,
    })

    setSearchResult(locations)
  }

  const selectLocation = (location: ILocationBase) => {
    const isSelected = selectedLocations.some((l) => l.slug === location.slug)

    if (isSelected) {
      return
    } // 選択済みの location の場合は 何もしない

    const newLocations = selectedLocations.concat(location)
    setFieldValue(newLocations)
  }

  return (
    <div>
      <InputSearchGroupWithDropDown
        isDropDownOpen={isDropDownOpen}
        onInputFinished={onInputFinished}
        closeDropDown={() => setIsDropDownOpen(false)}
        openDropDown={() => setIsDropDownOpen(true)}
        placeholder={t('場所を検索')}
        testid='searchLocationsField'
      >
        {isDropDownOpen && (
          <LocationSelectionField
            locations={searchResultExcludingSelected}
            onClickOption={(location) => selectLocation(location)}
          />
        )}
      </InputSearchGroupWithDropDown>
    </div>
  )
})
